import GuidedCampaignAudience from './components/GuidedCampaignAudience.js';
import connect from './connect';
import './assets/GuidedCampaignAudience.css';

export default connect(GuidedCampaignAudience);



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignAudience/index.js